import { Me } from '../../models/User'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'

interface UserState {
  isCurrentUserLoading: boolean
  currentUser: Me | null
}

const initialState: UserState = {
  isCurrentUserLoading: true,
  currentUser: null,
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setCurrentUserLoading: (state, action: PayloadAction<boolean>) => {
      state.isCurrentUserLoading = action.payload
    },
    setCurrentUser: (state, action: PayloadAction<Me>) => {
      state.currentUser = action.payload
    },
    resetCurrentUser: () => initialState,
  },
})

export const { setCurrentUserLoading, setCurrentUser, resetCurrentUser } = userSlice.actions

export const selectCurrentUser = (state: RootState) => state.meetingSummary.user.currentUser
